/**
 * Local auth bypass — when VITE_MOCK_AUTH=true, skip all Stytch
 * interactions and treat the user as authenticated with a mock session.
 *
 * The backend must also be running with DEV_AUTH_BYPASS=true so that
 * API requests (sent with credentials: 'include') are auto-authenticated.
 */

export { createLocalStytchStub, localAuthMockSession } from '@sequencehq/utils'

export function isLocalAuthBypass(): boolean {
  return import.meta.env.VITE_MOCK_AUTH === 'true'
}
